<div class=" scrollbar longtab" style="height: 500px;">
  <div class="card pad15 pt-0">
    <form [formGroup]="addOccasionalWorkingHoursForm" (ngSubmit)="AddWorkingHoursDetails()">
      <div class="mt-2 p-0">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-xl-9">
            <div class="row  ">
              <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                <label for="name" translate>lblOccasionName <span class="text-danger">*</span></label>
                <div class="lbl-info">
                  <input formControlName="occasionname" class="form-control mb-2" maxlength="30"
                    [ngClass]="{'is-invalid': (cpf.occasionname.touched || cpf.occasionname.dirty) && cpf.occasionname.errors}"
                    placeholder="Enter Occasion Name" [readonly]="isDisable">
                  <div *ngIf="(cpf.occasionname.touched || cpf.occasionname.dirty) && cpf.occasionname.errors">
                    <div *ngIf="cpf.occasionname.errors.required" class="help-block mt-1 text-danger" translate>
                      lblOccasionNameRequired</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                <label for="startDate" translate>lblStartDate<span class="text-danger">*</span>
                </label>
                <div class='date' *ngIf="!isDatesDisable">
                  <input class="form-control datePicker width100force mb-2" appAfDatepicker [startDate]="minDate"
                    required [dateTime]="false" placeholder="{{ 'lblEnterStartDate' | translate }}"
                    [disableNextMonthDates]="true" formControlName="startdate" [(ngModel)]="startdate"
                    id="txtboxStartDate" type="text" value="" autocomplete="off">
                  <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  <div *ngIf="(cpf.startdate.touched || cpf.startdate.dirty) && cpf.startdate.errors">
                    <div *ngIf="cpf.startdate.errors.required" class="help-block mt-1 text-danger" translate>
                      lblStartDateRequired</div>
                  </div>
                </div>
                <div class="lbl-info" *ngIf="isDatesDisable">
                  <input formControlName="startdate" class="form-control mb-2" maxlength="30" [(ngModel)]="startdate"
                    [ngClass]="{'is-invalid': (cpf.startdate.touched || cpf.startdate.dirty) && cpf.startdate.errors}"
                    [readonly]="true">
                </div>
              </div>

              <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                <label for="endDate" translate>lblEndDate</label>
                <div class='date' *ngIf="!isDatesDisable">
                  <input class="form-control datePicker mb-2" appAfDatepicker [startDate]="minDate"
                    placeholder="{{ 'lblEnterEndDate' | translate }}" required [dateTime]="false"
                    [disableNextMonthDates]="true" formControlName="enddate" [(ngModel)]="enddate" id="txtboxStartDate"
                    type="text" value="" autocomplete="off">
                  <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                </div>
                <div class="lbl-info" *ngIf="isDatesDisable">
                  <input formControlName="enddate" class="form-control mb-2" maxlength="30" [(ngModel)]="enddate"
                    [ngClass]="{'is-invalid': (cpf.enddate.touched || cpf.enddate.dirty) && cpf.enddate.errors}"
                    [readonly]="true">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-3 af-form-group pt-20">
            <button type="submit" class="btn btn-primary mb-2"
              [disabled]="!hasFormChanges" aria-label="Center Align"
              translate>lblSave</button>
            <button type="button" class="btn btn-primary ml-2 mb-2" aria-label="Center Align" (click)="OnClear()"
              translate>lblAddOccasion</button>
            <button type="button" class="btn btn-primary ml-2 mb-2" [hidden]="!isDelete" aria-label="Center Align"
              (click)="OnDelete()" translate>lblDelete</button>
          </div>

        </div>
      </div>
    </form>
    <div class="p-0">
      <div class="row">
        <div class="col-md-6 col-lg-6 col-xl-3 af-form-group"
          *ngFor="let item of dealerCustomerWaitingHoursOccasionList">
          <label class="mr10"><input name="options" ng-control="options" type="radio" [value]="item.rowId"
              (change)="ChangeOccasion()" [(ngModel)]="selectedRadioButton"> {{item.occasionName}}</label>
        </div>
      </div>
    </div>
    <div class="table-responsive tableMx-15 form-check pl-0" *ngIf="selectedRadioButton > 0">
      <table class="tablest1">
        <thead>
          <tr>
            <th style="width: 10%" class="text-center" scope="col" translate>lblIsActive</th>
            <th style="width: 15%" scope="col" translate>lblDay</th>
            <th style="width: 60%" scope="col" translate>lblSlots</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let workingHours of dealerCustomerWaitingWorkingHours; let i = index">
              <td class="text-center">
                <div class="custom-checkbox">
                  <input type="checkbox" [(ngModel)]="workingHours.isActive" [value]="true"
                    [checked]="workingHours.isActive" [id]="i" (change)="onIsActiveChange(workingHours)" />
                </div>
              </td>
              <td>{{workingHours.day}}</td>
              <td>
                <div class="lbl-info">
                  <div class="d-flex align-items-center">
                    <div class="date">
                      <ngb-timepicker [(ngModel)]="workingHours.deliveryTimeSlot"
                        [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                    </div>
                    <input type="text" [(ngModel)]="workingHours.maxCustomerWaitingNo"
                      [ngModelOptions]="{standalone: true}" class="waiting-customer ml-2"
                      (input)="onMaxCustomerWaitingNoInput(workingHours)"
                      placeholder="{{ 'lblMaxCustomerWaitingNo' | translate }}" inputmode="numeric" pattern="\d*"
                      min="0" max="99" maxlength="2" />
                    <button type="button" class="btn btn-primary ml-2" ngbTooltip="{{'lblAdd' | translate}}"
                      container="body" tooltipClass="custom-revert"
                      (click)="onTimeSlotAdd(workingHours.dayNumber,workingHours.occasionId)">
                      <em class="fa fa-plus"></em>
                    </button>
                    <div>
                      <div class="d-flex flex-wrap">
                        <div *ngFor="let slot of workingHours.waitingSlots">
                          <div class="time-slot d-flex justify-content-center align-items-center"
                            [ngClass]="slot.isAddedNew ? 'time-slot-new' : 'time-slot-existing'">
                            <span> {{slot.openingTime}} - ({{slot.maxCustomerWaitingNo}}) </span>
                            <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" container="body"
                              tooltipClass="custom-revert"
                              (click)="onTimeSlotDelete(workingHours.occasionId,slot.id,slot.openingTime,workingHours.dayNumber)"></em>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
  <div class="row">
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb10 mt5">
      <button class="btn btn-primary btn-lg" (click)="onSaveChanges(false)" aria-label="Center Align" translate
        [disabled]="checkFormChanges()">lblSaveChanges</button>
      <button class="btn btn-primary ml-2 btn-lg" (click)="onSaveChanges(true)" aria-label="Center Align" translate
        [disabled]="checkFormChanges()">lblSaveAndClose</button>
      <a (click)="OnClose()" class="btn btn-secondary ml-2 btn-lg" translate>lblCancel</a>
    </div>
  </div>
</div>